export type GameType = 'PARTY_LOOK_COLLECTION' | 'MOLE_ATTACK' | 'GET_OFF_WORK' | 'SLOT_DRESS_UP';

export interface GameResultModalProps {
  isOpen: boolean;
  score: number;
  gameType: GameType;
  gameResult: 'win' | 'lose' | null;
  resultId: number | null;
  onRestart: () => void;
  onCommentSubmit: () => void;
}

export const GAME_TYPE_KEYS: GameType[] = [
  'SLOT_DRESS_UP',
  'PARTY_LOOK_COLLECTION',
  'MOLE_ATTACK',
  'GET_OFF_WORK',
];

// 쿼리 파라미터용 키 (소문자, 짧은 이름)
export const GAME_QUERY_KEY = 'tab';

export const GAME_QUERY_PARAMS: Record<GameType, string> = {
  SLOT_DRESS_UP: 'party-look',
  PARTY_LOOK_COLLECTION: 'party-look-collection',
  MOLE_ATTACK: 'mole',
  GET_OFF_WORK: 'escape',
};

// 쿼리 파라미터 값으로 GameType 찾기
export const getGameTypeFromQuery = (query: string | undefined): GameType | null => {
  if (!query) return null;
  const entry = Object.entries(GAME_QUERY_PARAMS).find(
    ([, value]) => value === query.toLowerCase(),
  );
  return entry ? (entry[0] as GameType) : null;
};

export const GAME_TYPE_CONFIG: Record<GameType, { title: string; description: string }> = {
  SLOT_DRESS_UP: {
    title: 'X-MAS 파티룩',
    description: '슬롯으로 상배를 꾸미고 프로필을 선물 받아라!',
  },
  PARTY_LOOK_COLLECTION: {
    title: '↪︎ 파티룩 모음',
    description: '다른 유저들의 파티룩을 구경해보세요!',
  },
  MOLE_ATTACK: {
    title: '짭상배 퇴치',
    description: '뿅망치로 짭상배를 퇴치하라!',
  },
  GET_OFF_WORK: {
    title: '몰래 퇴근',
    description: '향로에게 들키지 말고 몰래 퇴근하라!',
  },
} as const;
